import { useState } from "react";
import { CardMedia, Skeleton } from "@mui/material";
import { onDragStart } from "utilities/dragndrop";
import { Media } from "types/qbank/media";

const HEIGHT = 160;

type IProps = {
  media: Media;
  thumbnailSrc: string;
  publishSrc: string;
  alt: string;
};

const CardImage = (props: IProps) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [failed, setFailed] = useState<boolean>(false);

  return (
    <>
      {!loaded && <Skeleton variant="rectangular" height={HEIGHT} />}
      <div style={{ backgroundColor: "#eee" }}>
        <CardMedia
          style={{width: "initial", maxWidth: "100%", objectFit: "contain", marginLeft: "auto", marginRight: "auto"}}
          classes={{img: 'is-checkered-background'}}
          component="img"
          height={loaded ? HEIGHT : 0}
          image={props.thumbnailSrc}
          alt={failed ? "Failed to load image" : props.alt}
          onLoad={() => {
            setLoaded(true);
          }}
          // @ts-ignore
          onError={(e) => {
            setFailed(true);
            setLoaded(true);
          }}
          draggable={!failed && loaded}
          onDragStart={(e: {
            dataTransfer: { dropEffect: string; effectAllowed: string };
          }) => onDragStart(props.publishSrc, props.alt, e)}
          onDragEnd={(e: any) => {
            // console.log("onDrop", e);
            // logUsage({
            //   sessionId: 1,
            //   sessionDetails: { username: "", email: "" },
            //   // @ts-ignore
            //   media: props.media,
            // });
          }}
        />
      </div>
    </>
  );
};

export default CardImage;
